import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.688 5.006v1.76a.787.787 0 0 1-.797.797H6.906v2.125h3.985c.431 0 .797.365.797.796v1.793l3.652-3.652zM17 8.625c0 .398-.166.764-.432 1.03l-3.851 3.85a1.53 1.53 0 0 1-1.096.432 1.503 1.503 0 0 1-1.527-1.527v-1.129H6.906a1.573 1.573 0 0 1-1.593-1.594V7.563c0-.864.697-1.594 1.593-1.594h3.188V4.873c0-.863.664-1.56 1.527-1.56.399 0 .797.166 1.096.464l3.851 3.852c.266.266.432.63.432.996M5.578 2.781H2.922c-.764 0-1.328.598-1.328 1.328v9.032c0 .763.564 1.328 1.328 1.328h2.656c.432 0 .797.365.797.797a.787.787 0 0 1-.797.797H2.922A2.905 2.905 0 0 1 0 13.14V4.109a2.926 2.926 0 0 1 2.922-2.921h2.656c.432 0 .797.365.797.796a.787.787 0 0 1-.797.797"
    }, null, -1)
  ])))
}
export default { render: render }